"use strict";

var _classCallCheck = require("/var/www/rememberme/admin/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/www/rememberme/admin/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Result = require("./Result");

var _Result2 = _interopRequireDefault(_Result);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Request serves as helper for the AnalysisWorkerWrapper.
 *
 * It holds the resolve and reject functions that it needs to fulfill the
 * promise. Any optional data will get included in the Result it can generate.
 */


var Request = /*#__PURE__*/function () {
  /**
   * Initializes a request.
   *
   * @param {Function} resolve The resolve function.
   * @param {Function} reject  The reject function.
   * @param {Object}  [data]   Optional extra data.
   */
  function Request(resolve, reject) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Request);

    this._resolve = resolve;
    this._reject = reject;
    this._data = data;
  }
  /**
   * Resolves the request with a result.
   *
   * @param {Object} [payload] Optional payload.
   *
   * @returns {void}
   */


  _createClass(Request, [{
    key: "resolve",
    value: function resolve() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var result = new _Result2.default(payload, this._data);

      this._resolve(result);
    }
    /**
     * Rejects the request with a result.
     *
     * @param {Object} [payload] Optional payload.
     *
     * @returns {void}
     */

  }, {
    key: "reject",
    value: function reject() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var result = new _Result2.default(payload, this._data);

      this._reject(result);
    }
  }]);

  return Request;
}();

exports.default = Request;